'use client';

import { useEffect } from 'react';

import { StepData } from '@/types/restResponses/steps';
import { preloadImages } from '@/utils/helpers';

interface UseImagePreloaderParams {
  steps: StepData[];
  activeStep: number;
  setActivePhoto: (photoIndex: number) => void;
}

/**
 * Custom hook for preloading gallery images and resetting active photo
 * Preloads images for the current step and resets active photo to 0
 */
export function useImagePreloader({ steps, activeStep, setActivePhoto }: UseImagePreloaderParams) {
  useEffect(() => {
    if (!steps?.[activeStep]?.media?.gallery) return;

    const imagesToPreload = steps[activeStep].media.gallery.map(img => img.medium_large);
    preloadImages(imagesToPreload);
  }, [steps, activeStep, setActivePhoto]);
}
